import React, { useEffect, useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import styles from "../onboard.module.css";
import { useMyContext } from "../../../myContext";
import CardDetail from "../../../common/CardDetails/CardDetail";
import { statusApi } from "../../../api";
import CommonButton from "../../CommonButton/CommonButton";

function VisitedRemitter({
  setReqDocs,
  showRemitterDetail,
  setShowRemitterDetail,
  remitterList,
  setShortDetail,
  setStepsToShow,
  remitterCardSelection,
  setRemitterCardSelection,
  clearSelectionTrigger,
}) {
  const [selectedRemitter, setSelectedRemitter] = useState(null);
  const [showNextButton, setShowNextButton] = useState(false);
  const {
    upadteUserId,
    setRemitterBankCardSelection,
    setShowKyc,
    showkyc,
    remitterSecondFlow,
    remitterUserId,
    setRemitterBankId,
    themeColor,
  } = useMyContext();

  useEffect(() => {
    if (clearSelectionTrigger > 0) {
      setSelectedRemitter(null);
      setShowNextButton(false);
    }
  }, [clearSelectionTrigger]);

  useEffect(() => {
    if (selectedRemitter) {
      if (selectedRemitter.userAccountId !== remitterUserId) {
        setRemitterBankId(null);
        upadteUserId(selectedRemitter.userAccountId);
      }
      checkKycApproved(selectedRemitter.userAccountId);
    }
  }, [selectedRemitter]);

  const hanldeNextClick = () => {
    if (showkyc === true) {
      setStepsToShow("RemitterStep2");
      setRemitterBankCardSelection(false);
    } else {
      setStepsToShow("RemitterStep3");
      setRemitterBankCardSelection(true);
    }
    setShowRemitterDetail(true);
    setRemitterCardSelection(false);
    setShortDetail({
      name: selectedRemitter.fullName,
      phone: selectedRemitter.phone,
      email: selectedRemitter.email,
      dob: selectedRemitter.dob,
      address: selectedRemitter.fullAddress,
      city: selectedRemitter.city,
      state: selectedRemitter.state,
      postalcode: selectedRemitter.postalCode,
      country: "India",
      userAccountId: selectedRemitter.userAccountId,
    });
  };

  const checkKycApproved = (id) => {
    setShowNextButton(false);
    setReqDocs([]);
    statusApi(id).then((res) => {
      setReqDocs([]);
      var documents = res.data.documents;
      const isAdhaarNo = !!(res.data.adhaarNo && res.data.adhaarNo);
      try {
        // Check if document exists and status is verified or pending
        const isDocumentValid = (doc) => {
          const status = doc?.status?.toLowerCase();
          return doc && (status === "verified" || status === "pending");
        };

        const allDocsPresent = isAdhaarNo
          ? isDocumentValid(documents.PAN) &&
            isDocumentValid(documents.AADHAAR_FRONT) &&
            isDocumentValid(documents.AADHAAR_BACK)
          : isDocumentValid(documents.PAN) &&
            isDocumentValid(documents.PASSPORT_FRONT) &&
            isDocumentValid(documents.PASSPORT_BACK);

        if (
          res.status === 200 &&
          Object.keys(documents).length === 3 &&
          allDocsPresent
        ) {
          setShowKyc(false);
        } else {
          if (Object.keys(documents).length !== 0) {
            const reqDocs = [];
            if (!isDocumentValid(documents.PAN)) {
              reqDocs.push("PAN");
            }
            if (isAdhaarNo) {
              if (!isDocumentValid(documents.AADHAAR_FRONT)) {
                reqDocs.push("Aadhaar");
              }
              if (!isDocumentValid(documents.AADHAAR_BACK)) {
                reqDocs.push("Aadhaar");
              }
            } else {
              if (!isDocumentValid(documents.PASSPORT_FRONT)) {
                reqDocs.push("Passport");
              }
              if (!isDocumentValid(documents.PASSPORT_BACK)) {
                reqDocs.push("Passport");
              }
            }
            setReqDocs(reqDocs);

            setShowKyc(true);
          } else {
            const reqDocs = ["PAN"];
            isAdhaarNo ? reqDocs.push("Aadhaar") : reqDocs.push("Passport");
            setReqDocs(reqDocs);
            setShowKyc(true);
          }
        }
        setShowNextButton(true);
      } catch (error) {
        setShowKyc(true);
        setShowNextButton(true);
      }
    });
  };

  return (
    <>
      {showRemitterDetail === false && (
        <>
          <CardDetail
            cardlist={remitterList}
            setSelectedValue={setSelectedRemitter}
            selectedValue={selectedRemitter}
            selectedUserid={remitterUserId}
          />
          {remitterCardSelection === true && remitterSecondFlow === true && (
            <Row className="pt-3 mt-3">
              <CommonButton
                title="Next"
                onClick={hanldeNextClick}
                loading={false}
                disabled={
                  (selectedRemitter !== null && showNextButton === null) ||
                  !showNextButton
                }
                width={"150px"}
              />
            </Row>
          )}
        </>
      )}
    </>
  );
}

export default VisitedRemitter;
